export default __webpack_public_path__ + "static/media/home.0613796a.svg";